var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.70161C0 1.75595 -5.36442e-08 1.28313 0.163068 0.921941C0.306499 0.604223 0.535373 0.345916 0.816888 0.184039C1.13692 -7.15256e-08 1.55587 0 2.39377 0H8.07896C8.91686 0 9.33584 -7.15256e-08 9.65586 0.184039C9.93735 0.345916 10.1663 0.604223 10.3097 0.921941C10.4727 1.28313 10.4727 1.75595 10.4727 2.70161V12.5717C10.4727 13.4198 10.4727 13.8439 10.3168 14.0718C10.1811 14.2702 9.97438 14.3904 9.75243 14.3997C9.49749 14.4104 9.19169 14.1639 8.58016 13.6709L5.23636 10.9753L1.89256 13.6709C1.28102 14.1639 0.975258 14.4104 0.720329 14.3997C0.498382 14.3904 0.291568 14.2702 0.155864 14.0718C1.43051e-07 13.8439 0 13.4198 0 12.5717V2.70161Z",
    fill: "#27387D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.75b4ac24d25455e9faa62404591a6f9e.svg";
export { ForwardRef as ReactComponent };